<template>

    <div style="min-height: 70vh" v-wechat-title="'mysread'">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container">
            <span>書架</span>
        </div>

        <div v-show="this.isLogin" class="book-list-container">

            <div class="book-display-container" v-for="book in bookList">
                <div @click="getBookDetail(book.id)">
                    <img :src="book.pic1" alt="" />
                    <span style="color: #333333">{{book.title}}</span>
                    <span>作者:{{book.author}}</span>
                    <span>狀態:{{book.zt}}</span>
                </div>
            </div>

        </div>

        <div v-show="!this.isLogin" style="margin-top: 40%">
            <img src="../assets/img_no_data.png" alt="" style="width: 30%" />
        </div>

    </div>

</template>

<script>
import axios from "axios";

export default {
    name: "BookShelfVue",

    data() {
        return {
            isLogin: false,
            userId: "",
            bookList: [],
            isRequest: false,
        };
    },

    methods: {
        //獲取書架數據
        getBookShelfData: function () {
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getBookShelf");
            params.append("uid", this.userId);
            this.isRequest = true;
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.bookList = res.data.data;
                } else {
                    alert(res.data.msg);
                }
            });
        },

        //獲取書籍詳情
        getBookDetail: function (bookId) {
            this.$router.push({
                path: "BookDetailVue",
                query: {
                    bookId: bookId,
                    vueName: "BookShelfVue",
                },
            });
        },
    },

    created() {
        this.userId = localStorage.getItem("userId");
        if (this.userId !== null && this.userId !== "null") {
            this.isLogin = true;
            this.getBookShelfData();
        } else {
            this.isLogin = false;
        }
    },
};
</script>

<style scoped>
.book-list-container {
    display: flex;
    flex-wrap: wrap;
    overflow-y: scroll;
    margin-top: 50px;
    margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/BookShelfVue.vue